// const baseUrlContentRoot = 'http://10.10.10.75:8899/web'
const baseUrlContentRoot = 'http://www.shanxifenghang.com/web'
    // const baseUrlContentRoot = 'http://www.fenghang-sx.com/web'
    // const baseUrlContentRoot = 'https://ceshi.yibaojie.cn'
    // const baseUrlContentRoot = 'http://ceshi.shanxifenghang.com';

function getUrl(url) {
    return `${baseUrlContentRoot}${url}`
}

export default getUrl